<div class="workout-overlay-counter-container" *ngIf="counter != -1">
  <div class="workout-overlay-counter text-center">
    <ng-container *ngIf="restTimer > 0">
      <div class="overlay-text">
        Rest
      </div>
      <div class="overlay-text-counter">{{ restTimerString }}</div>
      <button nbButton status="primary" shape="round" size="large" class="skip-rest-button" (click)="skipRest()">Skip
        Rest</button>
    </ng-container>
    <ng-container *ngIf="restTimer <= 0">
      <h1 class="overlay-text d-none">Exercise starting in</h1>
      {{ restTime }}
      <!-- Counter must be removed and created when counter changes (for animations)-->
      <!-- <h1
        *ngFor="let i of counter == null ? [] : [counter]"
        class="overlay-text-counter"
        @zoomInOnEnter
      >
        {{ counter || 'GO!' }}
      </h1> -->
      <h1 class="overlay-text-counter" @zoomInOnEnter>GO!
      </h1>
      <h1 class="overlay-text-counter" *ngIf="totalRestTime == 0">No Rest*</h1>
    </ng-container>
  </div>
</div>
<div class="workout-overlay-pause d-flex flex-column align-items-center" style="z-index: 1005">
  <!-- <button nbButton class="mb-1 px-2" *ngIf="workoutMode == WorkoutMode.Pause" (click)="onStopWorkout()">
    <i class="fa fa-ban mr-1"></i>
    Stop Workout?
  </button> -->
  <button class="d-flex align-items-center workout-btn" [ngClass]="{ pause: workoutMode == WorkoutMode.Workout }"
    nbButton (click)="
      timeStartStop()
    ">
    <i *ngIf="workoutMode == WorkoutMode.Workout" class="fa fa-2x fa-pause-circle mx-1"></i>
    <i *ngIf="workoutMode == WorkoutMode.Pause" class="fa fa-2x fa-play-circle mx-1 start"></i>
    <div class="px-2">
      Exercise {{ currentExercise }} <br />
      <i class="fa fa-clock"></i>
      {{ timerString }}
    </div>
  </button>
</div>